import { ContactService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

import $enDigits from "@/mixins/enDigits";

export default {
  name: "email",
  components: { CountDown },
  mixins: [$enDigits],
  data() {
    return {
      emailInput: "",
      emailCode: "",
      isEmailHover: false,
      isEmailFocus: false,
      isCountDownFinish: false,
      errorText: "",
      ttl: "",
      isRequesting: false
    };
  },
  computed: {
    ...mapGetters({
      isModalOpen: types.email.getters.IS_MODAL_OPEN,
      modalStep: types.email.getters.MODAL_STEP,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    dialogHeight() {
      switch (this.modalStep) {
        case 1:
          return "height: 320px;";

        case 2:
          return "height: 420px;";
      }
    },

    email() {
      return this.userInfo?.email;
    },

    emailModal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        this.setModal(val);
      }
    },

    isVerify() {
      return this.userVerify?.email_verification_status === "VERIFIED";
    },

    emailNameClass() {
      if (this.isEmailFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isEmailValid) {
          return "mobile_name_error";
        } else {
          if (this.emailInput) {
            return "mobile_name_fill";
          } else {
            if (this.isEmailHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isEmailValid() {
      const emailRegex = /\S+@\S+\.\S+/;
      if (this.emailInput) {
        return emailRegex.test(this.emailInput.toLowerCase());
      }
      return true;
    },

    isEmailCodeValid() {
      if (this.emailCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.emailCode);
      }
      return true;
    }
  },

  mounted() {
    if (this.email) {
      this.emailInput = this.email;
    }
  },

  methods: {
    ...mapActions({
      setStep: types.email.actions.SET_STEP,
      setModal: types.email.actions.SET_MODAL,
      setEmail: types.userVerifyInfo.actions.SET_EMAIL_STATUS
    }),

    checkValidation() {
      this.errorText = "";
      if (this.emailInput) {
        if (!this.isEmailValid) {
          this.errorText = this.$t(
            "accountPage.identityInformation.contactInfo.email.emailValidation.invalid"
          );
        }
      } else {
        this.errorText = this.$t(
          "accountPage.identityInformation.contactInfo.email.emailValidation.empty"
        );
      }
    },

    openModal() {
      this.setModal(true);
    },

    openModalStep1() {
      this.setStep(1);
      this.setModal(true);
    },

    // openModalStep2() {
    //   !this.isRequesting &&
    //     ContactService.activeEmail(this.email)
    //       .then(() => {
    //         this.setStep(2);
    //         this.setModal(true);
    //       })
    //       .finally(() => this.finishRequest());
    //   this.startRequest();
    // },

    closeEmailModal() {
      this.setModal(false);
    },

    setEmailHover(bool) {
      this.isEmailHover = bool;
    },

    toggleEmailFocus() {
      this.isEmailFocus = !this.isEmailFocus;
    },

    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = "";
    },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    resetCounter() {
      this.isCountDownFinish = false;
    },

    activeEmail() {
      this.checkValidation();
      if (this.emailInput && this.isEmailValid) {
        ContactService.activeEmail(this.emailInput)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetCounter();
            this.setStep(2);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    reActiveEmail() {
      ContactService.activeEmail(this.emailInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },

    verifyEmail() {
      if (this.isEmailCodeValid) {
        ContactService.verifyEmail(this.emailCode)
          .then(res => {
            this.setEmail("VERIFIED");
            this.closeEmailModal();
            this.$toast.success(res.data.message);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    }
  },

  watch: {
    emailCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.emailCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.emailCode = oldValue;
        }
      }
    },

    emailInput() {
      this.checkValidation();
    }
  }
};
